import store from '@/store';
import { ADMIN_OVERRIDE_ROLE_ENUMS, normalizeRole } from '@/constants/roles';

export const checkHasRole = requiredRole => {
  const requiredRoles = Array.isArray(requiredRole) ? requiredRole : [requiredRole].filter(Boolean);
  if (!requiredRoles.length) return true;

  const userRoles = store.state.auth.user?.roles || [];
  if (!userRoles.length) return false;

  const userSet = new Set(userRoles.map(normalizeRole).filter(Boolean));

  // Admin override: ADMIN / ACCOUNT_ADMIN (and SUPERADMIN if used) can see everything
  if (ADMIN_OVERRIDE_ROLE_ENUMS.some(r => userSet.has(r))) return true;

  return requiredRoles.map(normalizeRole).some(r => userSet.has(r));
};

// Helper used by router/menu: meta.roles -> roles
export const resolveRouteRoles = meta => {
  if (!meta) return [];
  const explicit = Array.isArray(meta.roles) ? meta.roles.filter(Boolean) : [];
  return explicit;
};
